/** Rota da Proposta: editor da versão ou PDF, com a trilha "#NNNN › Proposta NNNN/AAAA · vN" (DEMO-03). */
import { useRotuloTrilha } from '../../componentes/trilha.tsx';
import { versaoVigente } from '../../../../backend/src/compartilhado/propostas.ts';
import { ProvedorProposta, useProposta } from './contexto.tsx';
import { PropostaVersao } from './Proposta.tsx';
import { PropostaPdf } from './Documentos.tsx';
import { api } from '../../api.ts';
import { AvisoNaLixeira, useCarga, type NaLixeira } from '../ui.tsx';

export function TelaProposta({ oportunidadeId, propostaId, numero, pdf }: { oportunidadeId: string; propostaId?: string; numero?: number; pdf: boolean }) {
  return (
    <ProvedorProposta oportunidadeId={oportunidadeId}>
      <Conteudo propostaId={propostaId} numero={numero} pdf={pdf} />
    </ProvedorProposta>
  );
}

/** Proposta ausente: se o link aponta para uma Proposta na Lixeira (e o perfil pode vê-la lá), o aviso com o atalho. */
function SemProposta({ propostaId }: { propostaId?: string }) {
  const carga = useCarga(() => (propostaId ? api.get<{ lixeira: NaLixeira | null }>(`/api/lixeira/situacao?entidade=proposta&id=${encodeURIComponent(propostaId)}`) : Promise.resolve({ lixeira: null })), [propostaId]);
  if (carga.dados?.lixeira) return <AvisoNaLixeira lixeira={carga.dados.lixeira} teste="proposta" />;
  return <p className="vazio">Esta Oportunidade ainda não tem Proposta.</p>;
}

function Conteudo({ propostaId, numero, pdf }: { propostaId?: string; numero?: number; pdf: boolean }) {
  const { dados } = useProposta();
  const p = dados.proposta;
  const n = numero ?? (p ? versaoVigente(p).numero : undefined);
  useRotuloTrilha(p ? [`#${dados.oportunidade.numero}`, `Proposta ${p.numero}${n ? ` · v${n}` : ''}`, ...(pdf ? [`PDF v${n}`] : [])] : null);
  if (!p) return <SemProposta propostaId={propostaId} />;
  return pdf ? <PropostaPdf numero={n!} /> : <PropostaVersao numero={n} />;
}
